export default {
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  'The minimum time length is xxxs!': 'The minimum time length is {{num}}s!',
  'The maximum time length is 50s!': 'The maximum time length is 50s!',
  'Online service, no download required': 'Online service, no download required',
  'Add up to 20MB file': 'Add up to 20MB file',
  'Support common formats': 'Support common formats',
  'Best for general editing requirements': 'Best for general editing requirements',
  '0 second wait': '0 second wait',
  'No size limits': 'No size limits',
  'Support 1000+ formats': 'Support 1000+ formats',
  'Stable processing': 'Stable processing',
  'Get access to HitPaw Toolkit!': 'Get access to HitPaw Toolkit!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.',
  'The easiest video editing software for beginners':
    'The easiest video editing software for beginners',
  'Remove watermark from videos and images in simple clicks':
    'Remove watermark from videos and images in simple clicks',
  'TRY IT FREE': 'TRY IT FREE',
  'BUY NOW': 'BUY NOW',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ',
  'download the video': 'download the video',
  'and then use HitPaw Toolkit to proceed.': ' and then use HitPaw Toolkit to proceed.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'The file size cannot be larger than 20MB. Get HitPaw Toolkit for more features.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    'The minimum time length is 1s! Get HitPaw Toolkit for more features.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'Add 3 videos at most. Get HitPaw Toolkit for more features.',
  'This format is not supported currently.': 'This format is not supported currently.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'This format is not supported currently. Get HitPaw Toolkit for more formats.',
  'Processing failed. Get HitPaw Toolkit for stable processing.': 'Processing failed!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': 'Failed to load!',
  'Are you sure you want to delete it?': 'Are you sure you want to delete it?',
  'Failed to extract the audio!': 'Failed to extract the audio!',
  'Coming Soon': 'Coming Soon',
  'Learn more': 'Learn more',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'Add up to 2 files. Get HitPaw Toolkit for big file.',
  Download: 'Download',
  'Try Again': 'Try Again',
  Failed: 'Failed',
  'Get Started': 'Get Started',
  Start: 'Start',
  End: 'End',
  Export: 'Export',
  'Your audio is ready!': 'Your audio is ready!',
  'Download Audio': 'Download Audio',
  YES: 'Yes',
  'Export Failed': 'Export Failed',
  'Error occurs, the file cannot be added': 'Error occurs, the file cannot be added',
  'Support merging audio files at most': 'Support merging {{num}} audio files at most',
  'Are you sure you want to delete this task?': 'Are you sure you want to delete this task?',
  Processing: 'Processing',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    "Don't forget to download your file, it will be deleted after 24 hours.",
  Uploading: 'Uploading',
  'Go Edit': 'Go Edit',
  'Generate Files Successfully!': 'Generate Files Successfully!',
  'Your order is being paid...': 'Have you paid for your order?',
  'Not yet': 'Not Yet',
  'Payment completed': 'Yes',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
